class SystemError extends Error {
  errorCode: any
  errorCodeName?: string
  title?: string
  description?: string

  constructor(errorCode: number, message: string, title?: string, description?: string, errorCodeName?: string) {
    super()
    this.name = 'SystemError'
    this.errorCode = errorCode
    this.message = message
    this.title = title
    this.description = description
    this.errorCodeName = errorCodeName
  }
}

export function isSystemError(e: unknown): e is SystemError {
  return e instanceof Error && e.name === 'SystemError' && 'errorCode' in e && 'errorCodeName' in e
}

export default SystemError
